import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../store';

import { AuthState, BusinessType, PosState, TokenResponse, User, userStoreType } from './authTypes';

const initialState: AuthState = {
  user: null,
  business: null,
  accessToken: null,
  refreshToken: null,
  authLoading: false,
};
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authLoading(state) {
      state.authLoading = true;
    },
    loginSuccess(state, action: PayloadAction<{ user: User; tokens: TokenResponse }>) {
      state.user = action.payload.user;
      state.accessToken = action.payload.tokens.accessToken;
      state.refreshToken = action.payload.tokens.refreshToken;

      state.authLoading = false;
    },
    registerSuccess(state, action: PayloadAction<{ user: User; tokens: TokenResponse }>) {
      state.user = action.payload.user;
      state.accessToken = action.payload.tokens.accessToken;
      state.refreshToken = action.payload.tokens.refreshToken;
      state.authLoading = false;
    },
    posCreateSuccess(state, action: PayloadAction<{ pos: PosState }>) {
      if (state.user) {
        state.user.devicePOS = action.payload.pos;
        state.user.userPosCount += 1;
      }
    },
    selectStore(state, action: PayloadAction<{ store: userStoreType }>) {
      if (state.user) {
        state.user.activeStore = action.payload.store;
      }
    },
    setBusiness(state, action: PayloadAction<{ business: BusinessType }>) {
      state.business = action.payload.business;
    },
    logout(state) {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.authLoading = false;
    },
    refreshTokenSuccess(
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>
    ) {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
  },
});

export const {
  loginSuccess,
  registerSuccess,
  posCreateSuccess,
  selectStore,
  setBusiness,
  logout,
  refreshTokenSuccess,
  authLoading,
  setUser,
} = authSlice.actions;

export const selectUser = (state: RootState) => state.auth.user;
export const selectBusiness = (state: RootState) => state.auth.business;
export const selectAuthLoading = (state: RootState) => state.auth.authLoading;
export const selectActiveStore = (state: RootState) => state.auth.user?.activeStore;

export default authSlice.reducer;
